angular.module('components.caOrderContent', [])
    .component('caOrderContent', {
        templateUrl: 'main/order/ordersearch/components/ordercontent.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            order: '<',
            links: '<'
        },
        controller: controller
    })

// @ngInject
function controller(OrdersApiService, OrderService, AuthService, deliveryDocumentDownloadDialogService, ToasterService, loadSpinnerService, $translate, $state, confirmationDialogService, labelPrintingDialogService, updateOrderNoteDialogService, printPickingListDialogService, $rootScope) {
    var vm = this;
    vm.canAccess = AuthService.canAccess;

    //Properties
    vm.abs = Math.abs;
    vm.labelPrintingDialogVisible = false;
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.hasClaim = havePurchaseCostClaim();
    vm.sortContentBy = undefined;
    vm.sortContentReverse = undefined;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.scrollToSection = scroll;
    vm.goToOrderDelivery = goToOrderDelivery;
    vm.goToDeliveryPlanning = goToDeliveryPlanning;
    vm.getOrderAsPdf = getOrderAsPdf;
    vm.getOrderAsCsv = getOrderAsCsv;
    vm.canDeliverIn = canDeliverIn;
    vm.canEditOrder = canEditOrder;
    vm.isDeliveryPlanningEnabled = isDeliveryPlanningEnabled;
    vm.getOrderLabels = getOrderLabels;
    vm.deleteOrder = deleteOrder;
    vm.canDeleteOrder = canDeleteOrder;
    vm.canCopyOrder = canCopyOrder;
    vm.downloadDeliveryDocument = downloadDeliveryDocument;
    vm.showLabelPrintingDialog = showLabelPrintingDialog;
    vm.showPrintPickingListDialog = showPrintPickingListDialog;
    vm.selectOrderArticle = selectOrderArticle;
    vm.goToModifyOrder = goToModifyOrder;
    vm.goToCopyOrder = goToCopyOrder;
    vm.shouldShowFromLocation = shouldShowFromLocation;
    vm.shouldShowSupplier = shouldShowSupplier;
    vm.shouldShowDestination = shouldShowDestination;
    vm.updateOrderNote = updateOrderNote;
    vm.calculateDeliveredCost = calculateDeliveredCost;


    function onInit() {
        // Default to the only orderArticle if there's only one in the order.
        if (vm.order.orderArticles.length === 1) {
            vm.selectOrderArticle(vm.order.orderArticles[0]);
        }
    }
    function onChanges(changes) {

    }
    function onDestroy() {

    }

    function shouldShowSupplier() {
        return vm.order.orderType.orderSystemType === 'store' || vm.order.orderType.orderSystemType === 'automatic' || vm.order.orderType.orderSystemType === 'return';
    }
    function shouldShowFromLocation() {
        return vm.order.orderType.orderSystemType === 'internal' || vm.order.orderType.orderSystemType === 'automaticInternal' || vm.order.orderType.orderSystemType === 'return';
    }
    function shouldShowDestination() {
        return vm.order.orderType.orderSystemType !== 'return';
    }

    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read){
            return false
        }

        return true
    }

    function updateOrderNote() {
        var order = vm.order;
        updateOrderNoteDialogService.showDialog(order.id, order.orderNote, order.orderNumberExternal).then(function (response) {
            if (response.success === true) {
                vm.order.orderNote = response.note;
                vm.order.orderNumberExternal = response.orderNumberExternal;
            }
        });
    }

    function goToModifyOrder() {
        $state.go('order.modifyorder', { orderId: vm.order.id });
    }

    function goToCopyOrder() {
        $state.go('order.copyorder', { orderId: vm.order.id });
    }

    function selectOrderArticle(article) {
        vm.selectedOrderArticle = article;
    }

    function goToOrderDelivery() {
        $state.go("order.orderdelivery", { orderId: vm.order.id });
    }

    function goToDeliveryPlanning() {
        $state.go("order.deliveryPlanning", { orderId: vm.order.id });
    }

    function canDeliverIn() {
        return OrderService.canDeliverOrder(vm.links);
    }

    function isDeliveryPlanningEnabled() {
        return OrderService.isDeliveryPlanningEnabled(vm.links);
    }

    function canEditOrder() {
        return OrderService.canEditOrder(vm.links);
    }

    function canDeleteOrder() {
        return OrderService.canDeleteOrder(vm.links);
    }

    function canCopyOrder() {
        return OrderService.canCopyOrder(vm.links);
    }

    function getOrderAsPdf() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadAsPdf(vm.order.id).then(function (response) {
        }, function (error) {
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getOrderAsCsv(){
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadAsCsv(vm.order.id).then(function (response) {
        }, function (error) {
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getOrderLabels() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.downloadLabels(vm.order.id, vm.order.orderNumber).then(function (response) {
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteOrder() {
        confirmationDialogService.showDialog($translate.instant('order.confirmDeleteOrder')).then(function (result) {
            if (result === true) {
                loadSpinnerService.start('mainSpinner');
                OrdersApiService.deleteOrder(vm.order.id).then(function (response) {
                    ToasterService.showSuccess($translate.instant('order.orderDeleted'), $translate.instant('order.order'));
                    $state.go('order.ordersearch', null, { reload: true });
                }, function (error) {
                    ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                }).then(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function downloadDeliveryDocument() {
        deliveryDocumentDownloadDialogService.showDialog(vm.order.id).then(function (result) {
        });
    }

    function showLabelPrintingDialog() {
        labelPrintingDialogService.showDialog(vm.order);
    }

    function showPrintPickingListDialog() {
        printPickingListDialogService.showDialog().then(function (result) {
            if (result.result === true) {
                var request = {
                    orderId: vm.order.id,
                    includeStorageLocation: result.includeStorageLocation,
                    includeIsPhotographed: result.includeIsPhotographed,
                    includePrices: result.includePrices,
                    languageCode: result.languageCode,
                    grouping: result.grouping
                };

                loadSpinnerService.start('mainSpinner');
                OrdersApiService.downloadPickingList(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function calculateDeliveredCost(item) {
        var deliveredCost = 0;
        _.forEach(item.orderRows, function (oRow) {
            if (oRow.deliveryRows) {
                _.forEach(oRow.deliveryRows, function (dRow) {
                    if (dRow.systemStatus.toLowerCase() === 'delivered') {
                        deliveredCost += dRow.quantity * oRow.purchaseCost;
                    }
                });
            }
        });
        item.summarizedDeliveredCost = deliveredCost;
        return deliveredCost;
    }
}
